import { z } from 'zod';

// Filters out invalid items from the array
// Utility function to filter an array based on a given item schema
export const filteredArraySchema = <T extends z.ZodTypeAny>(itemSchema: T) =>
  z
    .array(z.any()) // Start with an array of any type to accept raw input
    .transform((items) => {
      return items
        .map((item) => itemSchema.safeParse(item)) // Validate each item
        .filter((result) => result.success) // Keep only successful validations
        .map((result) => result.data as z.infer<T>); // Extract the valid data
    });
